// Github: https://github.com/kievsash/ngx-material-tools
// Project: ngx-material-tools
// Original Author: Oleksandr Poshtaruk

import { Directive, ElementRef, forwardRef, HostListener, Input } from '@angular/core';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  standalone: false,
  selector: 'input[iesMatInputCommified]',
  providers: [
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: MatInputCommifiedDirective },
    {
      provide: NG_VALUE_ACCESSOR,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => MatInputCommifiedDirective),
      multi: true,
    },
  ],
})
export class MatInputCommifiedDirective {
  private _value: number | null;

  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  get value(): number | null {
    if (this._value) return this._value;
  }

  @Input('value')
  set value(value: number | null) {
    this._value = Number(value);
    this.formatValue(Number(value));
  }

  private formatValue(value) {
    if (value === null || value === '') this.elementRef.nativeElement.value = null;
    else this.elementRef.nativeElement.value = this.numberWithCommas(value);
  }

  private unFormatValue() {
    const value = this.elementRef.nativeElement.value;
    this._value = value ? Number(value.replace(/[^\d.-]/g, '')) : null;
    if (value) this.elementRef.nativeElement.value = Number(this._value).toFixed(2);
    else this.elementRef.nativeElement.value = '';
  }

  private numberWithCommas(x) {
    if (x === null || x === '') return '';
    const numberAsString = Number(x).toFixed(2);
    return numberAsString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value) {
    this._value = value.replace(/[^\d.-]/g, '');
    this._onChange(Number(this._value));
  }

  @HostListener('blur')
  _onBlur() {
    this.formatValue(this._value);
    this.touched();
  }

  @HostListener('focus')
  onFocus() {
    this.unFormatValue();
  }

  private _onChange;
  private touched;
  writeValue(value) {
    this._value = value;
    this.formatValue(this._value);
    // this._onChange(this._value);
  }

  registerOnChange(fn) {
    this._onChange = fn;
  }

  registerOnTouched(fn) {
    this.touched = fn;
  }
}
